import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewChildDecorator } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ScwMatButtonModule } from '../scw-mat-ui/scw-mat-button/scw-mat-button.module';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { IFile, EFileType } from '../../../store/file-upload/file-upload.model';
import { ImagePreviewModalComponent } from '../file-upload/image-preview-modal/image-preview-modal.component';
import _ from 'lodash';
import { FileUploadModule } from '../file-upload/file-upload.module';
import { filter, Subscription, take } from 'rxjs';
import { CameraModalComponent } from '../file-upload/camera-modal/camera-modal.component';
import { ScwMatFormModule } from '../scw-mat-ui/scw-mat-form/scw-mat-form.module';
import { ScwMatModalSeparatorModule } from '../scw-mat-ui/scw-mat-modal/scw-mat-modal-separator/scw-mat-modal-separator.module';
import { ScwMatSelectModule } from '../scw-mat-ui/scw-mat-select/scw-mat-select.module';
import { ScwMatTextareaModule } from '../scw-mat-ui/scw-mat-textarea/scw-mat-textarea.module';
import { ScwMatInputModule } from '../scw-mat-ui/scw-mat-input/scw-mat-input.module';
import * as oeeAppReducer from '../../../store/oee.reducer';
import { Store } from '@ngrx/store';
import * as ActionTrackerActions from '../../../store/action-tracker/action-tracker.actions';
import { ScwMatSelectRule } from '../scw-mat-ui/scw-mat-select/scw-mat-select.model';
import {
  EExternalDataSource,
  EItemType,
  IActionTrackerExternalMeta,
  TBoardMemberResponse,
  TBoardResponse,
  TSelectedBoard,
  TSelectedBoardMember,
} from 'src/app/store/action-tracker/action-tracker.types';
import { ELoadStatus } from '../../../../constants.model';
import { ScwMatInputRule } from '../scw-mat-ui/scw-mat-input/scw-mat-input.model';
import { ScwMatTextAreaRule } from '../scw-mat-ui/scw-mat-textarea/scw-mat-textarea.model';
import { ToastHelperService } from '../../service/toast/toast.helper.service';
import { FormHelperService } from '../../service/form/form.helper.service';
import { ScwMatDatepickerModule } from '../scw-mat-ui/scw-mat-datepicker/scw-mat-datepicker.module';
import {
  ScwMatDatepickerReturnInterface,
  ScwMatDatepickerRule,
} from '../scw-mat-ui/scw-mat-datepicker/scw-mat-datepicker.model';
import moment from 'moment';
import { IActionTrackerState } from '../../../store/action-tracker/action-tracker.reducer';
import { User } from '../../../store/user/model';
import { smallModalScrollable } from '../../../../constants';
import { IDropdownOption } from './create-quick-issue-action.type';
import { PageHeaderInterface } from '../../service/page-header/page-header.model';
import { PageHeaderService } from '../../service/page-header/page-header.service';
import { Line } from '../../../store/line/model';
import { Router } from '@angular/router';

type TFormRules = {
  name: ScwMatInputRule[];
  description: ScwMatTextAreaRule[];
  board: ScwMatSelectRule[];
  assignee: ScwMatSelectRule[];
  dueDate: ScwMatDatepickerRule[];
  itemType: ScwMatSelectRule[];
};

@Component({
  imports: [
    CommonModule,
    ScwMatButtonModule,
    ScwMatFormModule,
    ScwMatModalSeparatorModule,
    ScwMatSelectModule,
    ScwMatTextareaModule,
    ScwMatInputModule,
    TranslateModule,
    FileUploadModule,
    ScwMatDatepickerModule,
  ],
  selector: 'app-create-quick-issue-action-modal',
  templateUrl: 'create-quick-issue-action-modal.component.html',
  styleUrls: ['create-quick-issue-action-modal.component.scss'],
})
export class CreateQuickIssueActionModalComponent implements OnInit, OnDestroy {
  @ViewChild('quick_issue_action_modal')
  public readonly modelRef: ViewChildDecorator;

  @ViewChild('image_preview_modal', { static: false })
  public readonly imagePreviewModalComponent: ImagePreviewModalComponent;
  protected readonly EExternalDataSource = EExternalDataSource;

  public addedExternalSources: EExternalDataSource[] = [];
  public currentActivityText: string;
  public readonly formRules: TFormRules = {
    name: [this.formHelperService.getRequiredFormRule(), this.formHelperService.getMaxLengthFormRule(255)],
    description: [],
    board: [this.formHelperService.getRequiredFormRule()],
    assignee: [],
    itemType: [this.formHelperService.getRequiredFormRule()],
    dueDate: [],
  };

  public selectedBoards: TSelectedBoard[] = [];
  public selectedAssignees: TSelectedBoardMember[] = [];
  public readonly EFileType = EFileType;
  public files: IFile[] = [];
  public deletedFile: IFile;
  public selectedImage: IFile = null;
  public isPreviewModalClicked: boolean = false;
  public isUserExistInActionTracker: boolean | null = null;
  public fileDeleteConfirmationModalRef: NgbModalRef;
  public readonly subscriptions: Subscription[] = [];
  public boards$: TBoardResponse[] = [];
  public boardMembers$: TBoardMemberResponse[] = [];
  public readonly itemTypes: IDropdownOption<EItemType>[] = [
    { id: EItemType.issue, name: this.translate.instant('actionTracker.issue') },
    { id: EItemType.action, name: this.translate.instant('actionTracker.action') },
  ];

  public name: string = '';
  public description: string = '';
  public selectedDueDate: ScwMatDatepickerReturnInterface | null = null;
  public selectedItemTypes: IDropdownOption<EItemType>[] = [this.itemTypes[1]];
  public pageTitle: string = '';
  public pageUrl: string = '';
  public isPageUrlVisible: boolean = false;

  public isBoardsLoading: boolean = false;
  public isBoardMembersLoading: boolean = false;

  private isRecommendedBoardSelected: boolean = false;
  private dateTimeFormat$: string;
  private timezone$: string;
  private locale$: string;
  private externalMeta: IActionTrackerExternalMeta[] = [];

  constructor(
    private readonly ngbModal: NgbModal,
    private readonly activeModal: NgbActiveModal,
    private readonly store: Store<oeeAppReducer.OeeAppState>,
    private readonly toast: ToastHelperService,
    private readonly translate: TranslateService,
    private readonly formHelperService: FormHelperService,
    private readonly pageHeaderService: PageHeaderService,
    public router: Router,
  ) {}

  public ngOnInit(): void {
    this.dispatchInitialActions();
    this.createSubscriptions();
    this.deletedFile = null;
    this.isPreviewModalClicked = false;
  }

  public openPreviewModal(file: IFile, fileNumber: number): void {
    this.isPreviewModalClicked = true;
    this.imagePreviewModalComponent.openImagePreviewModal(
      file.folderId ? file.folderId : undefined,
      this.files,
      fileNumber,
    );
  }

  public onBoardDropdownDeselectAll(): void {
    this.boardMembers$ = [];
    this.selectedAssignees = [];
    this.selectedBoards = [];
  }

  public onSelectedBoardChange(): void {
    if (!this.selectedBoards || this.selectedBoards.length === 0) {
      this.selectedAssignees = [];
      return;
    }

    this.store.dispatch(ActionTrackerActions.getActionTrackerBoardMembers({ id: this.selectedBoards[0].id }));
  }

  public showDeleteItemModal(content: TemplateRef<unknown>, file?: IFile): void {
    this.deletedFile = this.files.find((item: IFile): boolean => item === file);

    this.fileDeleteConfirmationModalRef = this.ngbModal.open(content, smallModalScrollable);
  }

  public deleteImage(): void {
    if (!_.isNil(this.deletedFile) && this.deletedFile.folderId) {
      this.imagePreviewModalComponent.onDelete(this.deletedFile);
    }

    _.remove(this.files, this.deletedFile);
    this.fileDeleteConfirmationModalRef?.close();
    this.selectedImage = null;
  }

  public openModal(): void {
    this.ngbModal.open(this.modelRef);
  }

  public onFormSubmit(isValid: boolean): void {
    if (!isValid) {
      return;
    }

    let dueDate: string | undefined;

    if (this.selectedDueDate) {
      dueDate = moment(this.selectedDueDate.startDate, this.dateTimeFormat$, this.locale$)
        .tz(this.timezone$, true)
        .utc()
        .toISOString();
    }

    if (this.isPageUrlVisible && !_.isNil(this.pageUrl)) {
      this.description = `${this.description}<br><a href='${this.pageUrl}' title='${this.pageUrl}' target='_blank'>${this.pageTitle}</a>`;
    }

    this.externalMeta = this.externalMeta.filter(
      (m) => m.key && m.value && m.name && m.key !== '' && m.value !== '' && m.name !== '',
    );

    this.store.dispatch(
      ActionTrackerActions.createActionTrackerItem({
        payload: {
          externalMeta: this.externalMeta.length > 0 ? this.externalMeta : undefined,
          name: this.name.trim(),
          description: this.description?.trim(),
          boardId: this.selectedBoards[0].id,
          assigneeId: this.selectedAssignees?.[0]?.id ?? undefined,
          isQuick: true,
          itemType: this.selectedItemTypes?.[0]?.id ?? EItemType.issue,
          ...(dueDate ? { dueDate } : {}),
        },
      }),
    );
  }

  public closeModal(): void {
    this.store.dispatch(ActionTrackerActions.resetState());
    this.activeModal.close();
  }

  public deleteButtonClickedFromPreview(deletedFile: IFile): void {
    this.deletedFile = deletedFile;
    this.isPreviewModalClicked = false;

    _.remove(this.files, (file: IFile): boolean =>
      file.id
        ? file.id === deletedFile.id
        : file.fileOriginalName
        ? file.fileOriginalName === deletedFile.fileOriginalName
        : file.original === deletedFile.original,
    );
  }

  public onBoardSearch(searchKeyword: string): void {
    if (searchKeyword.length >= 40) {
      return;
    }

    this.store.dispatch(ActionTrackerActions.getActionTrackerBoards({ searchKeyword }));
  }

  public onAssigneeSearch(searchKeyword: string): void {
    if (searchKeyword.length >= 40) {
      return;
    }

    this.store.dispatch(
      ActionTrackerActions.getActionTrackerBoardMembers({ id: this.selectedBoards[0].id, searchKeyword }),
    );
  }

  public onAddLinkClick(): void {
    this.isPageUrlVisible = true;
    this.pageUrl = window.location.href;
  }

  public onAddExternalDataClick(source: EExternalDataSource): void {
    this.addedExternalSources.push(source);

    if (source === EExternalDataSource.home) {
      this.addCurrentActivity();
    }
  }

  public hiddenPageLink(): void {
    this.isPageUrlVisible = false;
    this.pageUrl = '';
  }

  public removeSource(source: EExternalDataSource): void {
    this.addedExternalSources = this.addedExternalSources.filter((item: EExternalDataSource) => item !== source);

    if (source === EExternalDataSource.home) {
      this.externalMeta = [];
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  private addCurrentActivity(): void {
    this.store
      .select('user')
      .pipe(take(1))
      .subscribe((user: User) => {
        this.externalMeta.push({ key: 'oeeLineId', value: user?.lineId, name: user?.lineName });
      });

    this.store
      .select('line')
      .pipe(take(1))
      .subscribe((state: Line) => {
        this.currentActivityText = state?.activityName;
        this.externalMeta.push({ key: 'oeeActivityId', value: state?.activityId, name: state?.activityName });
        this.externalMeta.push({ key: 'oeeTaskFolderId', value: state?.taskFolderId, name: state?.taskFolderName });
        this.externalMeta.push({ key: 'oeeTaskId', value: state?.taskId, name: state?.taskName });
        this.externalMeta.push({ key: 'oeeAuditLogUuid', value: state?.auditLogUuid, name: state?.auditLogUuid });
        this.externalMeta.push({ key: 'oeeWorkOrderId', value: state?.wOTableId, name: state?.workOrderId });
        this.externalMeta.push({
          key: 'activityStartTime',
          value: state?.activityStart,
          name: moment(state?.activityStart).format(this.dateTimeFormat$),
        });
      });
  }

  private dispatchInitialActions(): void {
    this.store.dispatch(ActionTrackerActions.getActionTrackerCurrentUser());
  }

  private createSubscriptions(): void {
    let isInitialCall: boolean = true;

    this.pageHeaderService.pageHeader.subscribe((item: PageHeaderInterface) => {
      this.pageUrl = window.location.href;
      this.pageTitle = item.title !== null ? item.title : this.processUrl(this.pageUrl);
    });
    this.subscriptions.push(
      this.store.select('user').subscribe((state: User): void => {
        this.timezone$ = state.timezone;
        this.dateTimeFormat$ = state.dateTimeFormat;
        this.locale$ = state.locale;
      }),
      CameraModalComponent.filesSubject.subscribe((files: IFile[]): void => {
        this.files = _.concat(this.files, files);
      }),
      this.store
        .select('actionTrackerStore')
        .pipe(
          filter((state: IActionTrackerState): boolean => state.recommendedBoardLoadStatus === ELoadStatus.Success),
          take(1),
        )
        .subscribe((state: IActionTrackerState): void => {
          if (state.recommendedBoard === null) {
            return;
          }

          this.selectedBoards = [{ id: state.recommendedBoard.boardId, name: state.recommendedBoard.boardName }];
          this.store.dispatch(
            ActionTrackerActions.getActionTrackerBoardMembers({ id: state.recommendedBoard.boardId }),
          );
        }),
      this.store.select('actionTrackerStore').subscribe((state: IActionTrackerState): void => {
        this.isBoardMembersLoading = state.boardMembersLoadStatus === ELoadStatus.Loading;
        this.isBoardsLoading = state.boardsLoadStatus === ELoadStatus.Loading;

        if (state.boardsLoadStatus === ELoadStatus.Failure) {
          this.boards$ = [];
        }

        if (state.boardsLoadStatus === ELoadStatus.Success) {
          this.boards$ = state.boards;

          if (!this.isRecommendedBoardSelected && state.boards.length > 0) {
            this.store.dispatch(ActionTrackerActions.getActionTrackerRecommendedBoard());
            this.isRecommendedBoardSelected = true;
          }
        }

        if (state.boardMembersLoadStatus === ELoadStatus.Failure) {
          this.boardMembers$ = [];
        }

        if (state.boardMembersLoadStatus === ELoadStatus.Success) {
          this.boardMembers$ = state.boardMembers;
        }

        if (state.createItemStatus === ELoadStatus.Success && state.createdItem) {
          if (this.files.length > 0) {
            this.store.dispatch(
              ActionTrackerActions.uploadActionTrackerItemAttachments({
                itemId: state.createdItem.id,
                boardId: state.createdItem.boardId,
                files: this.files.map((file: IFile) => this.convertBase64ToFile(file.original, file.fileOriginalName)),
              }),
            );
          }

          this.toast.showPersistentToastMessage(
            true,
            this.translate.instant('general.success'),
            `${this.translate.instant('actionTracker.itemCreated')}`,
            { url: state.createdItem.url, label: state.createdItem.key },
          );

          this.closeModal();
        }

        if (
          state.hasActionTrackerUserLoadStatus === ELoadStatus.Success &&
          state.hasActionTrackerUser !== this.isUserExistInActionTracker &&
          this.boards$.length === 0
        ) {
          if (!isInitialCall) {
            return;
          }

          this.isUserExistInActionTracker = state.hasActionTrackerUser;

          if (this.isUserExistInActionTracker && this.boardMembers$.length === 0) {
            this.store.dispatch(ActionTrackerActions.getActionTrackerBoards({}));
          }

          isInitialCall = false;
        }
      }),
    );
  }

  private processUrl(url: string): string {
    const parts: string[] = url.split('/').filter((part: string): boolean => part !== '');
    const lastPart: string = parts[parts.length - 1];
    return lastPart
      .split('-')
      .map((word: string): string => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private convertBase64ToFile(base64DataURI: string, fileName: string): File {
    const arr = base64DataURI.split(',');
    const mimeType = arr[0].match(/:(.*?);/)?.[1] || '';
    const base64 = arr[1];
    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }

    return new File([uint8Array], this.generateFileName(mimeType.startsWith('image/') ? 'png' : 'pdf', fileName), {
      type: mimeType,
    });
  }

  private generateFileName(extension: string, fileName?: string): string {
    let isFileNameHasExtension: boolean = false;

    const base: string = '%timestamp%%file_name%%extension%';
    const fileNameParts: string[] | null = fileName?.split('.') ?? null;

    if (
      fileNameParts &&
      fileNameParts.length >= 2 &&
      ['png', 'pdf'].includes(fileNameParts[fileNameParts.length - 1])
    ) {
      isFileNameHasExtension = true;
    }

    return base
      .replace('%timestamp%', fileName ? '' : `${Date.now().toString()}_`)
      .replace('%file_name%', fileName ?? crypto.randomUUID())
      .replace('%extension%', isFileNameHasExtension ? '' : `.${extension}`);
  }
}
